import React, { useState, useEffect } from "react";
// import tracking from '../assets/tracking.png';
// import safety from '../assets/safe.png';
// import hyperFastPng from '../assets/eta image.png';

// import alwaysOn from '../assets/always on.png';
// import marketPlace from '../assets/marketplace.png';
// import Topdivider from './svg/Topdivider';
// import dispatchRider from '../assets/dispatch.jpg';
// import microscopedoctor from '../assets/microscopeDoctor.png';
// import ussdPhone from '../assets/phoneUssd.png';
// import USSD from '../assets/ussd.png';
import gif from "../assets/gifmaker_me (1).gif";
import done from "../assets/Done.png";
import CardImg from "./CardImg";
const Cards = () => {
  {
    /* 
      <main className="flex  flex-col justify-center items-center w-full mb-10 ">
        <p className="font-bold font-lato lg:text-[35px] text-[23px] pb-16  xl:leading-12 md:leading-8 md: sm:leading-6 p-4 text-center text-gray-800">
          How we drive your hospital to unparalleled success
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 w-11/12 md:gap-8 justify-around md:w-8/12 lg:w-10/12">
          <div className="mx-auto justify-content items-center">
            <img
              src={microscopedoctor}
              alt="microscopicDoctor"
              className=" max-h-[308px] mx-auto  h-[200px] w-[255px]"
            />
            <div className="relative bottom-6">
              <div className="h-[40px] flex items-center justify-center bg-[#B80304] text-white mx-auto w-[270px] border rounded-md text-center">
                Safer Supplies
              </div>
              <div className="bg-white mx-auto h-[140px] w-[250px] text-center p-2 shadow-lg rounded-b-xl text-[17px]">
                Our 1000+ accredited vendors prioritize stringent safety
                standards mandated by the WHO and regulatory bodies
              </div>
            </div>
          </div>
          <div className="mx-auto justify-content items-center">
            <img
              src={ussdPhone}
              alt="microscopicDoctor"
              className=" max-h-[308px] mx-auto  h-[200px] w-[255px]"
            />
            <div className="relative bottom-6">
              <div className="h-[40px] flex items-center justify-center bg-[#B80304] text-white mx-auto w-[270px] border rounded-md text-center">
                Always Available
              </div>
              <div className="bg-white mx-auto h-[140px] w-[250px] text-center p-2 shadow-lg rounded-b-xl text-[17px]">
                We're there for you 24/7, everyday, even on weekends and
                holidays-saving lives nonstop.
              </div>
            </div>
          </div>
          <div className="mx-auto justify-content items-center">
            <img
              src={dispatchRider}
              alt="microscopicDoctor"
              className=" max-h-[308px] mx-auto rounded-2xl h-[200px] w-[255px]"
            />
            <div className="relative bottom-6">
              <div className="h-[40px] flex items-center justify-center bg-[#B80304] text-white mx-auto w-[270px] border rounded-md text-center">
                Quick & trackable delivery
              </div>
              <div className="bg-white mx-auto h-[140px] w-[250px] text-center p-2 shadow-lg rounded-b-xl text-[17px]">
                Get your hospital supplies delivered right to your hospital door
                in less than 50 minutes with one-tap order tracking for full
                visibility
              </div>
            </div>
          </div>
          <div className="mx-auto justify-content items-center">
            <img
              src={USSD}
              alt="microscopicDoctor"
              className=" max-h-[308px] mx-auto  h-[200px] w-[255px]"
            />
            <div className="relative bottom-6">
              <div className="h-[40px] flex items-center justify-center bg-[#B80304] text-white  mx-auto w-[270px] border rounded-md text-center">
                All-in-one marketplace
              </div>
              <div className="bg-white mx-auto h-[140px] w-[250px] text-center p-2 shadow-lg rounded-b-xl text-[17px]">
                Our Nerve app offers safe, fast , and trackable delivery of a
                wide range of medical supplies, along with 24/7 services
              </div>
            </div>
          </div>
        </div>
      </main> */
  }
  const [isMobile, setIsMobile] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 767) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }

      if (window.innerWidth > 767) {
        setIsDesktop(true);
      } else {
        setIsDesktop(false);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="flex flex-col md:flex-row justify-evenly items-center p-5" id="why-us">
        
        {isDesktop && <CardImg />}
        
       
        <div className="">
          <div className="flex flex-col justify-start items-center md:items-start md:gap-10">
            <p className="text-[30px] mb-0 leading-10 md:text-3.5xl font-lato font-extrabold mb-5">
              <strong>
                Your hospital’s key to
                <br className="" />
                <span className="underline text-[#B70303]">
                  unparalleled success
                </span>
              </strong>
            </p>

            <p className="font-lato text-[18px] mb-5 text-center md:text-left md:text-[25px] md-leading-15 md:mb-10">
              Get a comprehensive range of WHO-standard safe{" "}
              <br className="hidden md:inline" />
              medical supplies on Nerve 24/7, delivered to your{" "}
              <br className="hidden md:inline" />
              hospital in less than 50 minutes.
            </p>
          </div>

          <div className="flex justify-center md:justify-start gap-5 mt-5">
            <div className="flex flex-col font-bold justify-evenly">
              <div className="mb-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[15px] md:text-lg md:ml-10">
                  Safe Supplies
                </p>
              </div>
              <div className="gap-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[15px] md:text-lg md:ml-10">
                  Fast Deliveries
                </p>
              </div>
            </div>

            <div className="flex flex-col font-bold justify-evenly">
              <div className="mb-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[15px] md:text-lg md:ml-10">
                  Available 24/7
                </p>
              </div>
              <div className="gap-3">
                {" "}
                <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                  <img src={done} alt="" />
                </div>
                <p className="relative ml-6 font-lato text-[15px] md:text-lg md:ml-10">
                  Order Visibility
                </p>
              </div>
            </div>
          </div>
        </div>

        {isMobile && <CardImg />}
      </div>
    </>
  );
};

export default Cards;
